import { Link } from 'react-router-dom';
import type { Work } from '@/mocks/works';

interface WorkCardProps {
  work: Work;
}

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <Link
      to={`/works/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: '2 / 3' }}>
        <img
          src={work.cover}
          alt={`${work.title} 作品封面`}
          title={`${work.title} - 吉泽明步影视作品`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-0.5 text-[11px] font-medium text-primary-800 backdrop-blur">
          {work.type}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-primary-950/75 px-2.5 py-0.5 text-[11px] text-background-50">
          <i className="ri-star-fill text-accent-400" aria-hidden="true"></i>
          {work.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 line-clamp-1">
          {work.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span>{work.year}</span>
          <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
          <span>{work.roleType}</span>
        </div>
        <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600 line-clamp-2">
          {work.summary}
        </p>
        <span className="mt-4 inline-flex items-center gap-1 text-xs text-primary-700 group-hover:gap-2 transition-all">
          查看详情
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </span>
      </div>
    </Link>
  );
}